import styled from 'styled-components';
import { appSiderWidthStyle } from 'components/AppSider';

export const StyledSection = styled.section`
  ${appSiderWidthStyle};
  display: flex;
  justify-content: center;
  align-items: center;

  picture {
    display: flex;
    align-items: center;
    max-height: 50px;
  }

  img {
    padding-left: ${({ theme }) => theme.spacing.space_4};
    max-width: 210px;
    max-height: 50px;
    height: auto;
    width: auto;
  }
`;
